/** Onboarding (ALP-84 P4): 4 calm steps, Connect → How AI helps → Starter rules → Ready. */
export const onboarding = {
  stepOf: "Step {{n}} of {{total}}",
  back: "Back",
  next: "Continue",
  skip: "Skip for now",
  skipSetup: "Skip setup",
  finish: "Go to Home",
  steps: {
    connect: "Connect Instagram",
    ai: "How AI helps",
    rules: "Starter rules",
    ready: "Ready",
  },
  welcome: {
    title: "Welcome to Malfak, {{name}}",
    body: "Let's set up {{org}} in about two minutes. Malfak brings your Instagram comments and messages into one inbox, suggests replies in your voice, and handles the routine work with rules.",
  },
  connect: {
    title: "Connect Instagram",
    hint: "Malfak uses Meta's official login. We never see your password.",
    instagram: "Instagram",
    instagramHint: "Business or creator accounts. Comments, messages, publishing and insights.",
    connectInstagram: "Connect Instagram",
    connecting: "Connecting…",
    connected: "Connected",
    connectedAs: "Connected as @{{user}}",
    followers: "{{n}} followers",
    live: "Live updates",
    liveOn: "Live updates: on",
    liveOff: "Live updates: starting",
    redirecting: "Redirecting to Instagram…",
    failed: "We couldn't connect Instagram. Please try again.",
    soon: "Facebook, Messenger, WhatsApp, Threads and TikTok are coming soon.",
    needOne: "Connect an account to continue, or skip for now.",
    askAdmin: "Ask an owner or admin of {{org}} to connect Instagram. You can continue in the meantime.",
    rulesTitle: "What Instagram allows",
  },
  expect: {
    items: {
      inbox: "New comments and messages arrive live in one inbox, tagged by what they're about and how people feel.",
      window: "You can reply to a message freely within 24 hours of the customer's last message. After that the conversation locks until they write again.",
      privateReply: "You can send one private reply (a message) to each comment, within 7 days of it.",
      publishing: "You can publish up to 100 posts per account every 24 hours.",
      views: "Reach and views come straight from Instagram.",
      safety: "Nothing is ever sent without a rule you turned on, or your click.",
    },
  },
  ai: {
    title: "How AI helps",
    hint: "AI reads each new comment and message, tags it, and suggests a reply in your brand's voice. You decide what gets sent.",
    toggle: "AI for @{{user}}",
    suggest: "Suggest replies",
    suggestHint: "Suggestions wait in the inbox for you to send.",
    off: "Off",
    offHint: "No AI for this account. You can switch it on later in Settings.",
    noAccount: "Connect an account first to switch on AI.",
    safe: "Nothing is sent without you. You can change this any time in Settings → AI & knowledge.",
    modes: {
      auto: "Automatic",
      approve: "Ask me first",
      suggest: "Suggest only",
    },
  },
  rules: {
    title: "Start with a few proven rules",
    hint: "They start in Suggest only: AI prepares the reply and you send it. You can switch them to automatic later.",
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    none: "No starter rules available yet.",
    noAccount: "Connect an account to create starter rules. You can add them later from Rules.",
    create_one: "Create {{count}} rule",
    create_other: "Create {{count}} rules",
    creating: "Creating your rules…",
    created_one: "{{count}} rule created in Suggest only",
    created_other: "{{count}} rules created in Suggest only",
  },
  ready: {
    title: "You're all set",
    body: "Malfak is watching your account. New comments and messages show up in your inbox as they arrive, and Home walks you through your first replies.",
    next: "What's next",
    tips: {
      inbox: "Reply to your first comment with a suggested reply",
      rule: "Turn on a rule when you trust it",
      post: "Plan your next post at the best time",
    },
    invite: "Invite your team",
    inviteHint: "Add teammates from Settings → Team & roles.",
  },
};
